import React, { Component } from 'react';
import Search from '../components/search/search';
import Adapter from '../components/search/adapter';
import * as grpcWeb from 'grpc-web';
import Header from '../components/header';
import Footer from '../components/footer';
import { AdminServiceClient } from '../rpc/admin/AdminServiceClientPb';
import { SearchRequest, SearchResponse, AutocompleteRequest, AutocompleteResponse } from '../rpc/admin/search_pb';
import { getAuthMetadata } from '../helpers/rpc';
import Helmet from 'react-helmet';
import { PaddedContainer } from '../components/base';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { getUser } from '../helpers/user';

class SportsSouthProps { }

class SportsSouthState { }

class SportsSouthAdapter extends Adapter {

    protected performSearch(client: AdminServiceClient, request: SearchRequest): Promise<SearchResponse> {
        return new Promise((resolve, reject) => {
            client.sportsSouthSearch(request, getAuthMetadata(), (err: grpcWeb.Error, response: SearchResponse) => {
                if (!err) {
                    resolve(response);
                } else {
                    reject(err);
                }
            });
        });
    }

    performAutocomplete(client: AdminServiceClient, request: AutocompleteRequest): Promise<AutocompleteResponse> {
        return new Promise((resolve, reject) => {
            client.sportsSouthAutocomplete(request, getAuthMetadata(), (err: grpcWeb.Error, response: AutocompleteResponse) => {
                if (!err) {
                    resolve(response);
                } else {
                    reject(err);
                }
            });
        });
    }
}

class SportsSouth extends Component<SportsSouthProps & RouteComponentProps<any>, SportsSouthState> {

    private adapter: Adapter

    constructor(props: SportsSouthProps & RouteComponentProps<any>) {
      super(props);
      this.adapter = new SportsSouthAdapter(props.history);
    }

    render() {
        if (!getUser()) {
            return <div>Redirecting...</div>;
        }
        return (
            <>
                <Helmet>
                    <title>Sports South | Dashboard</title>
                </Helmet>

                <Header />

                <PaddedContainer>
                    <Search adapter={this.adapter} basePath="/sports-south/" />
                </PaddedContainer>

                <Footer />
            </>
        );
    }
}

export default withRouter(SportsSouth);